import { render, staticRenderFns } from "./Enigma1.vue?vue&type=template&id=ffab676e&scoped=true&"
import script from "./Enigma1.vue?vue&type=script&lang=js&"
export * from "./Enigma1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffab676e",
  null
  
)

export default component.exports